// Shared UI text: buttons, actions, statuses, hints reused across tool components
export default {
  action: {
    copy: 'Copy',
    clear: 'Clear',
    sample: 'Sample',
    paste: 'Paste',
    download: 'Download',
    upload: 'Upload',
    format: 'Format',
    compress: 'Minify',
    validate: 'Validate',
    encode: 'Encode',
    decode: 'Decode',
    convert: 'Convert',
    generate: 'Generate',
    reset: 'Reset',
    confirm: 'OK',
    cancel: 'Cancel',
    submit: 'Submit',
    save: 'Save',
    close: 'Close',
    swap: 'Swap',
    run: 'Run',
    add: 'Add',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    more: 'More'
  },
  status: {
    success: 'Success',
    failed: 'Failed',
    loading: 'Loading…',
    processing: 'Processing…',
    empty: 'No data',
    copied: 'Copied',
    copyFailed: 'Copy failed',
    noContent: 'Nothing to copy',
    done: 'Done'
  },
  hint: {
    quickAction: 'Quick actions',
    inputPlaceholder: 'Enter content',
    charCount: '{n} chars',
    lineCount: '{n} lines',
    requestFailed: 'Request failed'
  },
  unit: {
    times: '',
    items: '',
    years: 'years'
  }
}
